<ng-container>
    <div class="sectionTitle justify-content-space-between">
      <span class="display-flex align-items-center"><fa-icon icon="users-cog"></fa-icon>Users Management</span>

      <div *ngIf="hasAccountFilter" class="display-flex align-items-center">
        <label class="margin-right-small semibold-font font-size-small">Agency</label>
        <nz-select [(ngModel)]="selectedAccountId"
                   (ngModelChange)="onAccountFilterChange()"
                   nzShowSearch
                   [nzDisabled]="isDirty()"
                   nz-tooltip
                   [nzTooltipTitle]="isDirty() ? 'Save or discard your changes before switching agency' : ''"
                   class="account-filter"
                   id="users-account-filter" data-testid="users-account-filter">
          <nz-option [nzValue]="null" nzLabel="All agencies"></nz-option>
          <nz-option *ngFor="let account of accountOptions" [nzValue]="account.id" [nzLabel]="account.name"></nz-option>
        </nz-select>
      </div>
    </div>

     <nz-tabset #usersTabs
              *ngIf="users.length"
              class="users-tabset"
              [nzTabPosition]="'left'"
              nzType="line"
              [nzSelectedIndex]="selectedUserIndex"
              [nzTabBarExtraContent]="addUsersButtons">
  
  
        <nz-tab #userTab
                *ngFor="let user of users; let i = index"
                [nzTitle]="userTabTitle"
                (nzClick)="selectedUserIndex = i">
  
  
                <!-- TAB TITLE/BUTTON -->
                <ng-template #userTabTitle>
                  <div class="display-flex align-items-center justify-content-center">
                    <span style="margin-right: 6px; text-transform: capitalize"
                      [ngClass]="{'has-error': (!user.toBeRemoved && user.form && user.form.invalid) }"
                      [attr.data-testid]="getUserName(user)">
                      {{ getUserName(user) }}
                    </span>
                    <fa-icon icon="trash"
                            *ngIf="!user.id"
                            [style.color]="selectedUserIndex === i ? '' : '#bfbfbf'"
                            class="remove-unsaved-user-btn"
                            nz-tooltip
                            [nzTooltipTitle]="'Remove unsaved user'"
                            (click)="onRemoveUnsavedUser(i)">
                    </fa-icon>
                    <div class="to-be-deleted-stamp" *ngIf="user.toBeRemoved">TO BE DELETED</div>
                  </div>
                </ng-template>
  
                <!-- USER ACTIONS (MARK/UNMARK USER FOR DELETE) -->
                <div class="user-actions" *ngIf="selectedUserIndex !== null && users[selectedUserIndex].id">
                  <button type="button"
                          nz-button
                          nzBlock
                          nz-tooltip
                          [nzTooltipTitle]="user.toBeRemoved ? 'Undo mark' : 'Mark for deletion (applies only after saving the ' + entityName + ')' "
                          class="secondary-button red-button small-font small-height small-padding"
                          id="remove_user_button" data-testid="remove_user_button"
                          (click)="$event.preventDefault(); toggleUserDeleteStatus(selectedUserIndex)">
                    {{ user.toBeRemoved ? 'Undo Delete User' : 'Delete User' }}
                  </button>
                </div>
  
                <!-- TAB CONTENT -->
                <div [ngClass]="{'active': user.toBeRemoved}" class="disabled-overlay">
                  <app-user-management-update *ngIf="user"
                                              [updateOtherUserMode]="true"
                                              [userInput]="user"
                                              [publisher]="entity"
                                              [entityType]="entityType"
                                              [accountOptions]="accountOptions"
                                              [portfolioOptions]="portfolioOptions"
                                              [roleOptions]="roleOptions"
                                              (userOutput)="onUserFormChange($event, user)">
                  </app-user-management-update>
                </div>
  
        </nz-tab>
  
        <!-- ADD USER BUTTON -->
        <ng-template #addUsersButtons>
          <button nz-button class="add-button secondary-button small-font margin-top-1" id="add_user_button" data-testid="add_user_button" (click)="$event.preventDefault(); addUser()">
            Add User
          </button>
          <button nz-button [disabled]="hasApiUser()" *ngIf="canGenerateApiUser"
            class="add-button secondary-button small-padding smaller-font bold-font whitespace-prewrap margin-top-1"
            id="add_ext_user_button" data-testid="add_ext_user_button" (click)="$event.preventDefault(); addUser('API')">
            Generate API User
          </button>
        </ng-template>
  
  
    </nz-tabset>
  
    <!-- IN CASE THE ENTITY HAS NO USERS (THIS SHOULD NOT HAPPEN, BUT.. JUST IN CASE) - BANNER WITH ADD USER BUTTON -->
    <nz-spin [nzSpinning]="areUsersLoading" class="padding-bottom-2 padding-top-2" nzSize="large" nzTip='Fetching users...'></nz-spin>
  
    <nz-alert *ngIf="!areUsersLoading && users.length === 0" [nzMessage]="noUsersMessage" nzType="info"></nz-alert>
    <ng-template #noUsersMessage>
      <span>No users connected to this {{ entityName }}.</span>
      <button type="button" nz-button nzBlock class="add-first-user-button secondary-button small-font" id="add_first_user_btn" data-testid="add_first_user_btn" (click)="$event.preventDefault(); addUser()">
        Add User
      </button>
    </ng-template>
  
  
  </ng-container>
